"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearLocalStorage = exports.removeLocalStorageItem = exports.setLocalStorageItem = exports.getLocalStorageItem = void 0;
const astra_core_1 = require("astra-core");
const getLocalStorageItem = (key, defaultValue) => {
    var _a;
    try {
        if (astra_core_1.isBrowser) {
            return JSON.parse((_a = window.localStorage.getItem(key)) !== null && _a !== void 0 ? _a : JSON.stringify(defaultValue));
        }
        return defaultValue;
    }
    catch (err) {
        console.error('getStorageValueByKey', err);
        return defaultValue;
    }
};
exports.getLocalStorageItem = getLocalStorageItem;
const setLocalStorageItem = (key, valueToStore) => {
    try {
        if (astra_core_1.isBrowser) {
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        }
    }
    catch (error) {
        console.log(error);
    }
};
exports.setLocalStorageItem = setLocalStorageItem;
const removeLocalStorageItem = (key) => {
    try {
        if (astra_core_1.isBrowser) {
            window.localStorage.removeItem(key);
        }
    }
    catch (error) {
        console.log(error);
    }
};
exports.removeLocalStorageItem = removeLocalStorageItem;
const clearLocalStorage = () => {
    try {
        if (astra_core_1.isBrowser) {
            window.localStorage.clear();
        }
    }
    catch (error) {
        console.log(error);
    }
};
exports.clearLocalStorage = clearLocalStorage;
//# sourceMappingURL=locale-storage.js.map